<template>
  <div class="py-3"></div>
</template>


<script>
import pageMixin from '@/mixins/page.mixin'
import accessMixin from '@/mixins/access.mixin'

export default {
  mixins: [
    pageMixin,
    accessMixin
  ],

  data () {
    return {
    }
  }
}
</script>
